import React from 'react'
import { createRoot } from 'react-dom/client'

import { AppVerticalProvider } from '@cred/shared/AppVerticalContext'

import WidgetApp from 'WidgetApp'

import RateTableApp from './App'

const root = createRoot(document.getElementById('root'))
root.render(
  <WidgetApp>
    <AppVerticalProvider vertical="pl">
      <RateTableApp />
    </AppVerticalProvider>
  </WidgetApp>,
)
